import { escapeRegExp } from 'Helpers/regex'

import type { FindReplaceMode } from 'Pages/RecipientsList/model'

export const makePreviewRegExp = (
  findText: string,
  findType: FindReplaceMode,
  caseSensitive: boolean,
): RegExp | undefined => {
  if (findText.length === 0) {
    return undefined
  }

  const regExModifier = caseSensitive ? 'i' : undefined

  switch (findType) {
    case 'StartsWith':
      return new RegExp('^' + escapeRegExp(findText), regExModifier)

    case 'EndsWith':
      return new RegExp(escapeRegExp(findText) + '$', regExModifier)

    case 'Equals':
      return new RegExp('^' + escapeRegExp(findText) + '$', regExModifier)

    case 'Contains':
    default:
      return new RegExp(escapeRegExp(findText), regExModifier)
  }
}
